module.exports = __webpack_public_path__ + "img/cow2.d1a7a461.png";